import type { FC } from "react"

const Loupe: FC = () => {
  return (
    <svg
      fill="none"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m13.7111 13.763-3.0011-3.0188zm-1.338-7.05324c0 1.51433-.5991 2.96663-1.6656 4.03744-1.06639 1.0708-2.51278 1.6723-4.02095 1.6723s-2.95456-.6015-4.021-1.6723c-1.06643-1.07081-1.66555-2.52311-1.66555-4.03744 0-1.51432.59912-2.96662 1.66555-4.03741 1.06644-1.07079 2.51283-1.67235 4.021-1.67235s2.95456.60156 4.02095 1.67235c1.0665 1.07079 1.6656 2.52309 1.6656 4.03741z"
        stroke="#002800"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default Loupe
